export default __webpack_public_path__ + "static/media/logo.4c86b1dc.svg";